
import Vue, { PropType } from 'vue'
import { BulkTabletsTransactionRow } from '@/models'

import TabletBulkUploadListHeader from '@/views/company/tablets/components/TabletBulkUploadListHeader.vue'
import TabletBulkUploadListItem from '@/views/company/tablets/components/TabletBulkUploadListItem.vue'

export default Vue.extend({
  name: 'TabletBulkUploadList',

  props: {
    rows: Array as PropType<Array<BulkTabletsTransactionRow>>,
  },

  components: {
    TabletBulkUploadListHeader,
    TabletBulkUploadListItem,
  },
})
